import * as React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { permissionHelper, PublicAmorgUser } from '../../../amorg-common';
import { getActiveUser } from "../../../api/authClientApi";
import { getUser } from "../../../api/userClientApi";
import { SingleColumnLayout } from '../../_layouts/SingleColumnLayout';
import { PageHeader } from "../../../designSystem/PageHeader";
import { P } from '../../../designSystem/typography/Body';
import { clientAccessHelper } from '../../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../../_contexts/ProtectedPageContext';
import { MemberPageWrapper } from '../../_pageWrappers/MemberPageWrapper';
import UserPanel from "../../_components/userEditor/UserPanel";

type ParamTypes = Record<string, string | undefined>;

export interface UserPageState {
	activeUser: PublicAmorgUser | null,
	isAdmin: boolean
	user: PublicAmorgUser | undefined,

}

export default function UserPage(): JSX.Element {
    return (
        <MemberPageWrapper selectedMenuItemKey='users' breadCrumbs={[{text:'Brugere', url:'/users'}, {text:'Rediger bruger', url:''}]}>
            <PageHeader
                narrow
                headerText="Rediger bruger"
                headerStyle="secondary-gray" />
            <SingleColumnLayout narrow>
                <UserPageContent />
            </SingleColumnLayout>
        </MemberPageWrapper>
    );
}

function UserPageContent(): JSX.Element {

	const { userId } = useParams<{userId: string}>();
	const [state, setState] = useState<UserPageState>({
		activeUser: null,
		isAdmin: false,
		user: undefined
	});

	useEffect(() => {

		const getData = async () => {
            const activeUser = await getActiveUser();
            if(!activeUser)
                return;

            const isAdmin = activeUser.permissionGroup.permissions.includes('UserAdmin');
			const user = await getUser(userId || '');

			setState({ activeUser, isAdmin, user });
		};
		getData();

	}, []);

    const canEdit = state.activeUser && state.user
        ? state.activeUser.id === state.user.id || permissionHelper.canAdminEditTargetGroupId(state.activeUser?.permissionGroup.id, state.user?.permissionGroup.id, state.activeUser?.id === state.user?.id)
        : false;

    const protectedUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(protectedUser, ['ViewUsers']);

	return (
		    <>
          {!hasAccess
              ? <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>
              :
              <>
              {state.activeUser && state.user &&
                  <>
                      {canEdit ?
                          <>
                              <UserPanel activeUser={state.activeUser} targetUserId={state.user.id} onSelectedUserUpdated={() => { return; }} />
                          </>
                          :
                          <p>Du har ikke adgang til at redigere denne bruger</p>
                      }
                  </>
              }
              </>
          }
      </>
	);
}